import React, { useEffect } from 'react'
import Loader from 'components/Loader'
import { HousingTable } from 'components/Table/HousingTable'
import { useSelector, useDispatch } from 'react-redux'
import {fetchAllHousingInterests} from 'src/redux/housinginterest'


const Housing = () => {
  const dispatch = useDispatch()
  const { loading, interestedUsers = [] } = useSelector(
    state => state.housingInterest,
  )

  const housingData = interestedUsers.map(housing => ({
    email: housing.email,
    firstName: housing.firstName,
    lastName: housing.lastName,
    phone: housing.phone,
    message: housing.message,
    createdAt: new Date(housing.createdAt).toDateString(),
  }))

  useEffect(() => {
    dispatch(fetchAllHousingInterests())
  }, [])

  return <>{loading ? <Loader /> : <HousingTable data={housingData} />}</>
}

export default Housing
